module.exports = __webpack_public_path__ + "img/logo.b863a1f5.svg";